import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { PAGE_META, SITE } from '../../constants/seo';

const getPageMeta = (pathname) => {
    const matches = Object.keys(PAGE_META)
        .filter((key) => {
            if (key === '/') {
                return pathname === '/';
            }
            return pathname === key || pathname.startsWith(`${key}/`);
        })
        .sort((a, b) => b.length - a.length);

    return PAGE_META[matches[0]] || { title: SITE.title, description: SITE.description };
};

const getCanonicalUrl = (pathname) => {
    const base = SITE.url.replace(/\/+$/, '');
    return pathname === '/' ? `${base}/` : `${base}${pathname}`;
};

const setMetaTag = (name, content) => {
    let tag = document.querySelector(`meta[property="${name}"]`)
        || document.querySelector(`meta[name="${name}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(name.startsWith('og:') ? 'property' : 'name', name);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
};

const setCanonical = (href) => {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
    }
    link.setAttribute('href', href);
};

const Seo = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const meta = getPageMeta(pathname);
        const url = getCanonicalUrl(pathname);
        document.title = meta.title;
        setMetaTag('description', meta.description);
        setMetaTag('og:title', meta.title);
        setMetaTag('og:description', meta.description);
        setMetaTag('og:url', url);
        setMetaTag('twitter:title', meta.title);
        setMetaTag('twitter:description', meta.description);
        setCanonical(url);
    }, [pathname]);

    return null;
};

export default Seo;
